import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "button-container" }
const _hoisted_2 = { key: 1 }

import { ref, computed } from "vue";
import { useStore } from "vuex";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import ConfirmManualncomeVerificationModal from "@/components/modals/ConfirmManualncomeVerificationModal.vue";
import MeasureOneModal from "@/components/modals/MeasureOneModal.vue";
import { StipulationStatusIds } from "@/config/constants";
import NextButton from "@/components/shared/NextButton.vue";

interface Props {
  stip: Stipulation;
  applicant: Applicant;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AutomatedIncomeVerification',
  props: {
    stip: {},
    applicant: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const lenderId = computed<number>(() => store.state.appData?.application?.lenderId);

const modalRef = ref<InstanceType<typeof ConfirmManualncomeVerificationModal> | null>();
const measureOneModalRef = ref<InstanceType<typeof MeasureOneModal> | null>();

const showMeasureOneModal = ref<boolean>(false);
const manualCertification = ref<boolean>(false);
const measureOneEnabled = computed<boolean>(() => store.state.configuration?.measureOneEnabled);

const handleConnection = (event: any) => {
  console.log("Parent component received connection event:", event);
  // Perform actions like redirecting the user or displaying a success message
};

const openMeasureOneLinkWidget = () => {
  showMeasureOneModal.value = true;
};

function confirmManualCertification() {
  if (measureOneModalRef.value) {
    measureOneModalRef.value?.closeModal();
  }

  manualCertification.value = true;
  modalRef.value?.openModal();
}

function closeModal() {
  modalRef.value?.closeModal();
}

return (_ctx: any,_cache: any) => {
  return (__props.stip.stipulationStatusId === _unref(StipulationStatusIds).OPEN)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (measureOneEnabled.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(NextButton, {
                  class: "w-100",
                  onClick: openMeasureOneLinkWidget,
                  text: 'Start Verification'
                })
              ]),
              (showMeasureOneModal.value)
                ? (_openBlock(), _createBlock(MeasureOneModal, {
                    key: 0,
                    ref_key: "measureOneModalRef",
                    ref: measureOneModalRef,
                    lenderId: lenderId.value,
                    applicant: __props.applicant,
                    stip: __props.stip,
                    onSuccess: _cache[0] || (_cache[0] = ($event: any) => (emit('success'))),
                    onDatasourceConnected: handleConnection,
                    onConfirmManualCertification: confirmManualCertification,
                    onClose: _cache[1] || (_cache[1] = ($event: any) => (showMeasureOneModal.value = false))
                  }, null, 8, ["lenderId", "applicant", "stip"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", { class: "link-container mt-11" }, [
                _createElementVNode("a", {
                  class: "text-decoration-underline",
                  onClick: confirmManualCertification
                }, "Click here to submit income documents instead")
              ]),
              _createVNode(ConfirmManualncomeVerificationModal, {
                ref_key: "modalRef",
                ref: modalRef,
                stip: __props.stip,
                applicant: __props.applicant,
                manualCertification: manualCertification.value,
                onClose: closeModal
              }, null, 8, ["stip", "applicant", "manualCertification"])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, "MeasureOne is not enabled for this lender"))
      ], 64))
    : _createCommentVNode("", true)
}
}

})